import cls from 'classnames';
import { useTranslation } from 'next-i18next';

import avatorDefault from '@public/imgs/home-chinese-en.png';

import { ICourseInfo } from '../interface';

import styles from './styles.module.scss';
interface IProps {
  data?: Partial<ICourseInfo>;
  language?: string;
  routeToGs2Booking?: () => void;
  bookingCategory?: string; // 新增 bookingCategory 参数
}

const Step4 = ({ data, routeToGs2Booking, bookingCategory }: IProps) => {
  const { teacherName, teacherAvator = avatorDefault?.src } = data || {};
  const { t, i18n } = useTranslation(['trailCourse']);

  // 根据 bookingCategory 显示不同的文案
  const getSuccessMessage = () => {
    if (bookingCategory === 'basicTrial') {
      // 普通体验约课文案
      return (
        <span>
          {t('取消课程-步骤四描述1-普通体验约课')}
          <a className={styles.link} onClick={routeToGs2Booking}>
            {t('取消课程-步骤四-再次预约-普通体验约课')}
          </a>
          {t('取消课程-步骤四描述2-普通体验约课')}
        </span>
      );
    } else {
      // GS2.0 约课文案（保持原有逻辑）
      return (
        <span>
          {t('取消课程-步骤四描述1')}
          <a className={styles.link} onClick={routeToGs2Booking}>
            {t('取消课程-步骤四-再次预约')}
          </a>
          {t('取消课程-步骤四描述2')}
        </span>
      );
    }
  };

  return (
    <div
      className={cls(styles.step4MainContent, 'mobile:mt-[24px] pc:mt-[32px]')}>
      <div className={styles.left}>
        <div className={styles.avatorBox}>
          <img className={styles.avator} src={teacherAvator} alt="avator" />
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.name}>{teacherName}</div>
        <div
          className={cls(
            styles.dialog,
            'mobile:mt-[8px] mobile:p-[16px] pc:mt-[16px] pc:p-[24px]',
          )}>
          {getSuccessMessage()}
        </div>
      </div>
    </div>
  );
};

export default Step4;
